export enum ApiScope {
  MAIN = 'main',
  FOOTER1 = 'footer1',
  FOOTER2 = 'footer2',
  EDITORIAL_SUMMARY = 'editorial_summary'
}

export interface Menu {
  id?: number
  description?: string
  url?: string
  parentId?: number
  itemOrder?: number
  scope?: ApiScope
  status?: string
  newTab?: boolean
  rel?: string
  target?: string
  menus?: Menu[]
}

export type MenuResponse = { menus: Menu[] }
export type Scope = 'navbar' | 'footer1' | 'footer2'
export type Menus = {
  main: Menu[]
  footer1: Menu[]
  footer2: Menu[]
  editorial_summary: Menu[]
}
